var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.447 9.50918C1.26078 6.60321 3.11721 3.33398 5.99461 3.33398C7.60316 3.33398 8.90774 4.06048 10.0002 5.51347L10.1378 5.33563C11.2018 4.0012 12.4642 3.33398 14.0057 3.33398C16.8831 3.33398 18.7395 6.60321 17.5533 9.50918C17.0587 10.721 15.9295 12.1843 14.1659 13.8991C13.1113 14.9246 11.8283 16.0115 10.9672 16.7197C10.4034 17.1834 9.59689 17.1834 9.03312 16.7197C8.17204 16.0115 6.88905 14.9246 5.8344 13.8991C4.0708 12.1843 2.94166 10.721 2.447 9.50918Z",
    stroke: "#808387",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.8b7b0e32239a73883dd1b7fa9b7caf73.svg";
export { ForwardRef as ReactComponent };